import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Contacts from './Contacts';
import CustomerContacts from './CustomerContacts';
import useAuthContext from '../../contexts/AuthContext';

const ContactsRouter = () => {
  const { user } = useAuthContext();

  const ContactsComponent =
    user?.role === 'guests:GUEST' ? CustomerContacts : Contacts;

  return (
    <Routes>
      <Route index element={<ContactsComponent />} />
    </Routes>
  );
};

export default ContactsRouter;
